function safeParse(value, fallback = null) {
  try {
    return JSON.parse(value)
  } catch {
    return fallback
  }
}

export const setItem = (key, value) => {
  try {
    const serialized = JSON.stringify(value)
    localStorage.setItem(key, serialized)
  } catch (e) {
    console.error(`Storage set error for key "${key}":`, e)
  }
}

export const getItem = (key, defaultValue = null) => {
  try {
    const item = localStorage.getItem(key)
    return item ? safeParse(item, defaultValue) : defaultValue
  } catch (e) {
    console.error(`Storage get error for key "${key}":`, e)
    return defaultValue
  }
}

export const removeItem = key => {
  try {
    localStorage.removeItem(key)
  } catch (e) {
    console.error(`Storage remove error for key "${key}":`, e)
  }
}

export const clearStorage = () => {
  try {
    localStorage.clear()
  } catch (e) {
    console.error(`Storage clear error:`, e)
  }
}



// WEBPACK FOOTER //
// ./src/modules/shared/utils/persistent.storage/index.js